const getObsClient = function(){
	let ak = "DU8JKCY8QVHLE24Y3SLT",
		sk = "Ok2dF9JLxUV8UvdMpzzWCJD2S3nvfJxXAWLprzUz",
		server = "http://obs.cn-east-2.myhuaweicloud.com"
	return new ObsClient({
		access_key_id: ak,
		secret_access_key: sk,
		server: server,
		timeout: 60 * 5
	})
}

export default getObsClient


// WEBPACK FOOTER //
// ./src/utils/getObsClient.js